import { UpdateSnapshotAction } from '../types/team-member';

export const updateSnapshot = (
  snapshot: UpdateSnapshotAction['payload']['snapshot'],
): UpdateSnapshotAction => ({
  payload: { snapshot },
  type: '@@team-member/UPDATE_SNAPSHOT',
});
